// Safely coerce an axios/API error into a display string (never an object/array),
// so pydantic 422 `detail` arrays can't crash React via toast.error.
export function errText(e, fallback = "Something went wrong.") {
  const d = e?.response?.data;
  if (!d) return e?.message && e.message !== "cancelled" ? e.message : fallback;
  if (typeof d.message === "string") return d.message;
  if (typeof d.detail === "string") return d.detail;
  if (Array.isArray(d.detail)) return d.detail.map((x) => x?.msg || x?.message || "invalid input").join("; ") || fallback;
  if (typeof d.error === "string") return d.error;
  return fallback;
}
